import { createReducer, on } from '@ngrx/store';
import * as ExpenseStatusActions from './expense-status.actions';
import { ExpenseStatus } from './expense-status.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface ExpenseStatusState {
    allStatus: ExpenseStatus[];
    singleStatus: ExpenseStatus | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialExpenseStatusState: ExpenseStatusState = {
    allStatus: [],
    singleStatus: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Expense Statuses Reducer
export const expenseStatusReducer = createReducer(
    initialExpenseStatusState,

    // On Load ExpenseStatuses
    on(ExpenseStatusActions.loadAllExpenseStatus, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ExpenseStatusActions.loadAllExpenseStatusSuccess,
        (state, { status }) => ({
            ...state,
            isLoading: false,
            allStatus: status,
        })
    ),
    on(
        ExpenseStatusActions.loadAllExpenseStatusFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error: error,
        })
    ),

    // On Load Single ExpenseStatus
    on(ExpenseStatusActions.loadExpenseStatus, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseStatusActions.loadExpenseStatusSuccess, (state, { status }) => ({
        ...state,
        isLoading: false,
        singleStatus: status,
    })),
    on(ExpenseStatusActions.loadExpenseStatusFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(ExpenseStatusActions.createExpenseStatus, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ExpenseStatusActions.createExpenseStatusSuccess,
        (state, { status }) => ({
            ...state,
            isLoading: false,
            allStatus: [...state.allStatus, status],
        })
    ),
    on(ExpenseStatusActions.createExpenseStatusFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(ExpenseStatusActions.updateExpenseStatus, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ExpenseStatusActions.updateExpenseStatusSuccess,
        (state, { status }) => ({
            ...state,
            isLoading: false,
            allStatus: state.allStatus.map((st) =>
                st.id === status.id ? status : st
            ),
        })
    ),
    on(ExpenseStatusActions.updateExpenseStatusFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(ExpenseStatusActions.deleteExpenseStatus, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseStatusActions.deleteExpenseStatusSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        allStatus: state.allStatus.filter((st) => st.id !== id),
    })),
    on(ExpenseStatusActions.deleteExpenseStatusFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
